module.exports = __webpack_public_path__ + "img/master.572b6d3.svg";